import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import {
  Edit,
  Delete,
} from '@mui/icons-material';
import { ProgramVersionItemDto } from '../../../api/types/dtos/program';

interface VersionItemCardProps {
  item: ProgramVersionItemDto;
  allItems: ProgramVersionItemDto[];
  onEdit: (item: ProgramVersionItemDto) => void;
  onDelete: (itemId: string) => void;
  disabled?: boolean;
}

const VersionItemCard: React.FC<VersionItemCardProps> = ({
  item,

  onEdit,
  onDelete,
  disabled = false,
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleDelete = () => {
    if (item.id) {
      onDelete(item.id);
      setDeleteDialogOpen(false);
    }
  };

  return (
    <>
      <Card
        sx={{
          mb: 2,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            boxShadow: 2,
          },
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Typography variant="h6" component="div">
                  {item.name}
                </Typography>
                {item.cpNumber && (
                  <Chip
                    label={`CP: ${item.cpNumber}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                )}
              </Box>

              {item.description && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {item.description}
                </Typography>
              )}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {item.programLevelId && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Nivel:</strong> {item.programLevelId}
                  </Typography>
                )}
                {item.measurementTypeId && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Tipo de Medición:</strong> {item.measurementTypeId}
                  </Typography>
                )}
                {item.measurementTemplate && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Plantilla:</strong> {typeof item.measurementTemplate === 'string' 
                      ? 'Formulario definido' 
                      : item.measurementTemplate.title || 'Formulario definido'}
                  </Typography>
                )}
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Tooltip title="Editar">
                <IconButton
                  size="small"
                  onClick={() => onEdit(item)}
                  disabled={disabled}
                  color="primary"
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Eliminar">
                <IconButton
                  size="small"
                  onClick={() => setDeleteDialogOpen(true)}
                  disabled={disabled}
                  color="error"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar el item &quot;{item.name}&quot;? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VersionItemCard;

